export const sizes = [24, 48, 72]

export const sortOptions = [
    {
        id: 'score',
        value: {
            name: 'Bestsellers',
            frName: 'Recommandé',
            sort: [
                {
                    field: 'score',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: '-price',
        value: {
            name: 'Price (High to Low)',
            frName: 'Prix Décroissant',
            sort: [
                {
                    field: 'price',
                    order: 'desc',
                },
            ],
        },
    },
    {
        id: 'price',
        value: {
            name: 'Price (Low to High)',
            frName: 'Prix Croissant',
            sort: [
                {
                    field: 'price',
                    order: 'asc',
                },
            ],
        },
    },
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteSize: 4,
    historySize: 5,
    currency: 'USD'
}

export const isFrench = 
    (window.TMW?.localization?.languageCode === 'FR') || 
    (window.Shopify?.locale === 'fr') || false;

export const popularSearchTerms = {
    en: [
        "Body Mists",
        "Reed Diffusers Liquid Refill",
        "Wall Diffuser",
        "Bamboo",
        "Grapefruit"
    ],
    fr: [
        "Brume Corporelle",
        "Recharge pour diffuseur de parfum d'intérieur",
        "Diffuseur mural",
        "Bambou",
        "Pamplemousse"
    ]
}

export const facetNameTranslations = {
    'Category': 'Catégorie',
    'Subcategory': 'Sous-catégorie',
    'Fragrance': 'Parfum',
    'Price': 'Prix'
}

// collections with diffusers & refill groups
export const collectionGroupConfig = {
    "162332082230" : [ // categoryId
        {
            tag: "nosto_reed-diffuser",
            title: {
                en: "Reed Diffusers",
                fr: "Diffuseurs à roseaux",
            },
            link: {
                en: "Reed Diffusers",
                fr: "Diffuseurs à roseaux",
            },
            description: {
                en: "Our Reed Diffusers are crafted with high-quality fragrance oils to deliver exquisite fragrance, flame-free and uninterrupted.",
                fr: "Nos diffuseurs à roseaux sont fabriqués avec des huiles parfumées de haute qualité pour offrir un parfum exquis, sans flamme et sans interruption.",
            },
        },
        {
            tag: "nosto_reed-diffuser-refill",
            title: {
                en: "Reed Diffuser Liquid Refills",
                fr: "Recharges pour diffuseur à roseaux"
            },
            description: {
                en: "Replenish your empty Reed Diffuser so you can continue to enjoy up to 90 days of your favorite scent. Includes complimentary Reed Sticks ($7.00 value).",
                fr: "Reconstituez votre diffuseur à roseaux vide pour pouvoir continuer à profiter jusqu'à 90 jours de votre parfum préféré. Comprend des bâtons de roseaux gratuits (valeur de CA$10.00)"
            },
            link: {
                en: "Refills",
                fr: "Recharges",
            },
        },
    ],
    "600403476680" : [
        {
            tag: "nosto_portable-diffuser",
            title: {
                en: "Portable Fragrance Diffusers",
                fr: null,
            },
            link: {
                en: "Portable Fragrance Diffusers",
                fr: null,
            },
            description: {
                en: "Scent your state of mind anytime, anywhere with this compact, rechargeable device that lets you create your own scented sanctuary no matter where you are.",
                fr: null,
            },
        },
        {
            tag: "nosto_diffuser-oil-drops-refill",
            title: {
                en: "Diffuser Oil Drops",
                fr: null,
            },
            link: {
                en: "Diffuser Oil Drops",
                fr: null,
            },
            description: {
                en: "Fragrances that enhance well-being specifically formulated for use with NEST New York electronic diffusers, including the Portable Fragrance Diffuser.",
                fr: null,
            },
        },
    ],
    "290011054280" : [
        {
            tag: "nosto_wall-diffuser",
            title: {
                en: "Wall Diffusers",
                fr: "Diffuseurs muraux",
            },
            link: {
                en: "Wall Diffusers",
                fr: "Diffuseurs muraux",
            },
            description: {
                en: "Enjoy your favorite NEST New York fragrances in this effortless format that lets you enjoy extraordinary fragrance for 30 uninterrupted days.",
                fr: "Profitez de vos parfums NEST New York préférés dans ce format sans effort qui vous permet de profiter d'un parfum extraordinaire pendant 30 jours ininterrompus.",
            },
        },
        {
            tag: "nosto_wall-diffuser-refill",
            title: {
                en: "Refills for Wall Diffusers",
                fr: "Recharges pour diffuseurs muraux",
            },
            link: {
                en: "Refills",
                fr: "Recharges",
            },
            description: {
                en: "A set of two refills to be used with a NEST New York Wall Diffuser.",
                fr: "Un lot de deux recharges à utiliser avec un diffuseur mural NEST New York.",
            },
        },

    ],
    "434526486728" : [
        {
            tag: "nosto_misting-diffuser",
            title: {
                en: "Misting Diffusers",
                fr: "Diffuseurs brumisateurs"
            },
            link: {
                en: "Misting Diffusers",
                fr: "Diffuseurs brumisateurs",
            },
            description: {
                en: "Create a wellness sanctuary with this electronic device that uses ultrasonic technology to humidify and scent the atmosphere with fragrances that enhance well-being.",
                fr: "Créez un sanctuaire de bien-être avec cet appareil électronique qui utilise la technologie des ultrasons pour humidifier et parfumer l'atmosphère avec des parfums qui favorisent le bien-être."
            },
        },
        {
            tag: "nosto_diffuser-oil-drops-refill",
            title: {
                en: "Diffuser Oil Drops",
                fr: "Gouttes d'huile pour diffuseur"
            },
            link: {
                en: "Diffuser Oil Drops",
                fr: "Huile de diffuseur",
            },
            description: {
                en: "Fragrances that enhance well-being specifically formulated for use with NEST New York electronic diffusers, including the Misting Diffuser.",
                fr: "Des parfums qui améliorent le bien-être spécialement formulés pour être utilisés avec les diffuseurs électroniques NEST New York, y compris le diffuseur brumisateur."
            },
        },
    ],
    "162421768246" : [
        {
            tag: "nosto_pura-diffuser",
            title: {
                en: "NEST x Pura Diffusers",
                fr: null,
            },
            link: {
                en: "NEST x Pura Smart Fragrance Diffusers",
                fr: null,
            },
            description: {
                en: "The ultimate in fragrance technology, this app-based device connects to your phone, letting you set a scent schedule, swap between scents, and adjust intensity from anywhere.",
                fr: null,
            },
        },
        {
            tag: "nosto_pura-refill",
            title: {
                en: "Refills for NEST x Pura Smart Fragrance Diffusers",
                fr: null,
            },
            link: {
                en: "Refills",
                fr: null,
            },
            description: {
                en: "A set of two refills to be used with the NEST x Pura Smart Fragrance Diffuser.",
                fr: null,
            },
        },
    ],
    "608755056840": [ // TEST COLLECTION
        {
            tag: "nosto_reed-diffuser",
            title: {
                en: "Reed Diffusers",
                fr: "Diffuseurs à roseaux",
            },
            link: {
                en: "Reed Diffusers",
                fr: "Diffuseurs à roseaux",
            },
            description: {
                en: "Our Reed Diffusers are crafted with high-quality fragrance oils to deliver exquisite fragrance, flame-free and uninterrupted.",
                fr: "Nos diffuseurs à roseaux sont fabriqués avec des huiles parfumées de haute qualité pour offrir un parfum exquis, sans flamme et sans interruption.",
            },
        },
        {
            tag: "nosto_reed-diffuser-refill",
            title: {
                en: "Reed Diffuser Liquid Refills",
                fr: "Recharges pour diffuseur à roseaux"
            },
            description: {
                en: "Replenish your empty Reed Diffuser so you can continue to enjoy up to 90 days of your favorite scent. Includes complimentary Reed Sticks ($7.00 value).",
                fr: "Reconstituez votre diffuseur à roseaux vide pour pouvoir continuer à profiter jusqu'à 90 jours de votre parfum préféré. Comprend des bâtons de roseaux gratuits (valeur de CA$10.00)"
            },
            link: {
                en: "Refills",
                fr: "Recharges",
            },
        },
    ],
}
